/*
**************************** 
홈페이지 가입
*****************************
*/

import axios from "axios";
import React, { useContext, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../App";
import PopupDom from "./PopupDom";

export default function Regist() {
    const { choiceValue, setValue } = useContext(MyContext);
    const navigate = useNavigate();

    const confirmNumber = useRef();
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const openPostCode = function () {
        setIsPopupOpen(true);
    }
    const closePostCode = function () {
        setIsPopupOpen(false);
    }

    const { register, handleSubmit, watch, reset } = useForm({ shouldUseNativeValidation: true });
    const submit = async function (data) {
        const userName = data.userName;
        const email = data.email;
        const phone = data.phone;
        const _address = address;

        const subAddress = data.subAddress;
        const password = data.password;
        const rePassword = data.rePassword;

        const login_id = data.login_id;

        if (password !== rePassword) {
            alert("비밀번호가 다릅니다.");
            return;
        }

        if(_address == undefined || _address == "" || _address == null){
            alert("우편번호 검색으로 주소를 입력해 주세요");
            return;
        }

        const reqSql = "/api/users/user";
        const params = { userName, login_id, email, phone, _address, subAddress, password, rePassword };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.status === 200 || res.status === 201) {
                const reqSql = "/api/users/auth";
                const params = { login_id, password };
                axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
                    if (res.status === 200) {
                        sessionStorage.setItem("state", "true");
                        sessionStorage.setItem("userId", res.data.id);
                        sessionStorage.setItem("userName", res.data.userName);
                        sessionStorage.setItem("toktokSerial", res.data.toktokSerial);

                        alert("가입 성공");
                        if (sessionStorage.getItem("buyType") != null) {
                            setValue({ ...choiceValue, userId: res.data.id, amount: choiceValue.amount, prodcutColor: choiceValue.productColor, productAmount: choiceValue.productAmount });

                            const buyTarget = sessionStorage.getItem("buyTarget");
                            navigate("/" + buyTarget);

                            window.closeRegist();
                            window.buyProcess();
                        } else {
                            window.location.href = "/";
                        }

                    } else {
                        if (res.status === 204) {
                            alert("로그인 실패");
                        } else if (res.status === 205) {
                            alert("회원 가입은 본인 인증이 필요합니다.");
                        } else {
                            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                        }
                    }
                }).catch(function (err) {
                    console.log(err);
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                });
            } else {
                if (res.status === 409) {
                    alert("등록된 아이디입니다.");
                } else if (res.status === 205) {
                    alert("회원 가입은 본인 인증이 필요합니다.");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            if (err.response.status === 409) {
                alert("등록된 아이디입니다.");
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    const userVerify = async function () {
        const reqSql = "/api/verify";
        const phoneNumber = confirmNumber.current;

        var user_phone = phoneNumber;
        const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;

        let check = "";
        if (user_phone !== undefined && user_phone.length > 0) {
            check = user_phone.replace(regExp, "");
        } else {
            alert('연락처를 다시 한 번 확인하세요.');
            return;
        }

        if (user_phone == '' || user_phone.length < 10 || check.length < 10 || user_phone.length > 11) {
            alert('연락처를 다시 한 번 확인하세요.');
            return;
        }

        const params = { phoneNumber };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.status === 200) {
                const niceCallUrl = res.data.niceCallUrl;
                window.open(niceCallUrl, "userVerify", "scrollbars=no, location=no, toolbar=no, width=700, height=700, ");
            } else {
                if (res.status === 204) {
                    alert("본인인증 실패");
                } else {
                    alert("본인인증 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            alert("본인인증 도중 오류가 발생하였습니다.");
        });
    }

    const [address, setAddress] = useState("");
    const callBackAddress = function (address) {
        setAddress(address);
    }
    return (
        <div>
            <div>
                <div className="modal fade" id="regist" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold" id="exampleModalLabel">회원가입</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                    reset();
                                }}></button>
                            </div>
                            <div className="modal-body">
                                <div className="sign-up">
                                    <form action="#" onSubmit={handleSubmit(submit)}>
                                        <div className="form-group text-start">
                                            <label htmlFor="userName" className="form-label mt-4">이름:</label>
                                            <input type="text" className="form-control" placeholder="이름을 입력해 주세요" name="userName"  {...register("userName", { required: true })}></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="login_id" className="form-label mt-4">아이디:</label>
                                            <input type="text" className="form-control" placeholder="아이디를 입력해 주세요" name="login_id"  {...register("login_id", { required: true })}></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="email" className="form-label mt-4">이메일:</label>
                                            <input type="email" className="form-control" placeholder="이메일을 입력해 주세요" name="email" {...register("email", {
                                                required: true
                                            })}></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="phone" className="form-label mt-4">전화번호(‘-’를 제외하고 숫자만 입력해주세요):</label>
                                            <input type="tel" className="form-control" placeholder="전화번호를 입력해 주세요" name="phone" {...register("phone", {
                                                required: true
                                            })} onChange={function (e) {
                                                confirmNumber.current = e.target.value;
                                            }} ></input>
                                        </div>
                                        <div className="form-group row p-2">
                                            <button type="button" className="btn btn-info " onClick={() => {
                                                userVerify();
                                            }}>본인인증</button>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="address" className="form-label mt-4">주소:</label><span><button type="button" className="btn btn-info small m-2" onClick={() => {
                                                openPostCode();
                                            }}>우편번호 검색</button></span>
                                            <input type="text" className="form-control" placeholder="주소를 입력해 주세요" value={address} {...register("address")}></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="subAddress" className="form-label mt-4">상세 주소:</label>
                                            <input type="text" className="form-control" placeholder="상세 주소를 입력해 주세요" name="subAddress" {...register("subAddress", {
                                                required: true
                                            })}></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="password" className="form-label mt-4">비밀번호:</label>
                                            <input type="password" className="form-control" placeholder="비밀번호를 입력해 주세요" name="password"  {...register("password", {
                                                required: true,
                                                minLength: {
                                                    value: 8,
                                                    message: "8자리 이상 비밀번호를 사용하세요.",
                                                }
                                            })}></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="rePassword" className="form-label mt-4">비밀번호 확인:</label>
                                            <input type="password" className="form-control" placeholder="비밀번호를 입력해 주세요" name="rePassword"  {...register("rePassword", {
                                                required: true,
                                                minLength: {
                                                    value: 8,
                                                    message: "8자리 이상 비밀번호를 사용하세요.",
                                                }
                                            })}></input>
                                        </div>
                                        <div className="form-group text-start mt-4">
                                            <h6><input type="checkbox" className="form-check-input" name="l4service" required></input><span ><a className="p-2 text-muted text-decoration-bottom" href="https://peach-margin-2a3.notion.site/d6da601eddaa4953a20daf459ba61da0" target="_blank" onClick={() => {
                                                window.open(this.href, 'l4service', 'width=430,height="400", location=no,status=no,scrollbars=yes');
                                            }}>서비스이용 동의</a></span></h6>
                                            <h6><input type="checkbox" className="form-check-input" name="l4private" required></input><span ><a className="p-2 text-muted text-decoration-bottom" href="https://peach-margin-2a3.notion.site/fd1b89b6ea534e659809b6fcb8c9ae58" target="_blank" onClick={() => {
                                                window.open(this.href, 'l4private', 'width=430,location=no,status=no,scrollbars=yes');
                                            }}>개인정보 수집 및 이용 동의</a></span></h6>
                                        </div>
                                        <div className="form-group mt-4 row p-2">
                                            <button type="submit" className="btn btn-lg btn-primary" onClick={(e) => {
                                            }}>가입하기</button>
                                        </div>
                                    </form>
                                    <div>
                                        {isPopupOpen === true ? <PopupDom open={true} close={closePostCode} header="우편번호 검색" onClose={closePostCode} dataCall={callBackAddress}></PopupDom> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}